import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'reviewDeal.title',
    defaultMessage: 'View your total deal summary',
  },
  subtitle: {
    id: 'reviewDeal.subtitle',
    defaultMessage: 'Summary',
  },
  itemTitle: {
    id: 'reviewDeal.itemTitle',
    defaultMessage: 'Item details',
  },
  financeTitle: {
    id: 'reviewDeal.financeTitle',
    defaultMessage: 'Financing details',
  },
  deliveryTitle: {
    id: 'reviewDeal.deliveryTitle',
    defaultMessage: 'Delivery date',
  },
  emailOverride: {
    id: 'reviewDeal.emailOverride',
    defaultMessage: 'Signature email override',
  },
  emailLabel: {
    id: 'reviewDeal.emailLabel',
    defaultMessage: 'Email',
  },
  invalidEmail: {
    id: 'reviewDeal.invalidEmail',
    defaultMessage: 'Please enter a valid email address',
  },
  sidebarTitle: {
    id: 'reviewDeal.sidebarTitle',
    defaultMessage: 'Net cash summary',
  },
  attestationCheckbox: {
    id: 'reviewDeal.attestationCheckbox',
    defaultMessage: 'By ticking this box you agree that all information above is correct.',
  },
  documentSendMessage: {
    id: 'reviewDeal.documentSendMessage',
    defaultMessage: 'Do not send the documents for signature(s) until the day of delivery',
  },
  saveButton: {
    id: 'reviewDeal.saveButton',
    defaultMessage: 'Save and close',
  },
  completeButton: {
    id: 'reviewDeal.completeButton',
    defaultMessage: 'Complete purchase and financing now',
  },
  itemLabel: {
    id: 'reviewDeal.itemLabel',
    defaultMessage: 'Item',
  },
  modelLabel: {
    id: 'reviewDeal.modelLabel',
    defaultMessage: 'Model',
  },
  colorLabel: {
    id: 'reviewDeal.colorLabel',
    defaultMessage: 'Color',
  },
  totalLabel: {
    id: 'reviewDeal.totalLabel',
    defaultMessage: 'Total',
  },
  customerNameLabel: {
    id: 'reviewDeal.customerNameLabel',
    defaultMessage: 'Customer name',
  },
  totalAmountFinancedLabel: {
    id: 'reviewDeal.totalAmountFinancedLabel',
    defaultMessage: 'Total amount financed',
  },
  monthlyRepaymentLabel: {
    id: 'reviewDeal.monthlyRepaymentLabel',
    defaultMessage: 'Monthly Payment',
  },
  repaymentPeriodLabel: {
    id: 'reviewDeal.repaymentPeriodLabel',
    defaultMessage: 'Terms',
  },
  aprLabel: {
    id: 'reviewDeal.aprLabel',
    defaultMessage: 'Interest Rate',
  },
  confirmedHINLabel: {
    id: 'reviewDeal.confirmedHINLabel',
    defaultMessage: 'Confirmed HIN',
  },
  confirmedVINLabel: {
    id: 'reviewDeal.confirmedVINLabel',
    defaultMessage: 'Confirmed VIN',
  },
  confirmedTrailerLabel: {
    id: 'reviewDeal.confirmedTrailerLabel',
    defaultMessage: 'Trailer serial number',
  },
  confirmedEngineLabel: {
    id: 'reviewDeal.confirmedEngineLabel',
    defaultMessage: 'Engine serial number',
  },
  netFloorplanBalanceLabel: {
    id: 'reviewDeal.netFloorplanBalanceLabel',
    defaultMessage: 'Net floorplan balance',
  },
  subsidisedFinancingEndDateLabel: {
    id: 'reviewDeal.subsidisedFinancingEndDateLabel',
    defaultMessage: 'Subsidised financing end date',
  },
  conditionLabel: {
    id: 'reviewDeal.conditionLabel',
    defaultMessage: 'New or used',
  },
  nadaValueLabel: {
    id: 'reviewDeal.nadaValueLabel',
    defaultMessage: 'NADA amount',
  },
  invoiceValueLabel: {
    id: 'reviewDeal.invoiceValueLabel',
    defaultMessage: 'Invoice amount',
  },
  basePurchasePriceLabel: {
    id: 'reviewDeal.basePurchasePriceLabel',
    defaultMessage: 'Base purchase price',
  },
  feesAndTaxesLabel: {
    id: 'reviewDeal.feesAndTaxesLabel',
    defaultMessage: 'Fees and taxes',
  },
  backendProductsLabel: {
    id: 'reviewDeal.backendProductsLabel',
    defaultMessage: 'Backend products',
  },
  financableAccessoriesLabel: {
    id: 'reviewDeal.financableAccessoriesLabel',
    defaultMessage: 'Financable accessories',
  },
  rebateLabel: {
    id: 'reviewDeal.rebateLabel',
    defaultMessage: 'Rebate',
  },
  downPaymentLabel: {
    id: 'reviewDeal.downPaymentLabel',
    defaultMessage: 'Down payment',
  },
  participationFeeLabel: {
    id: 'reviewDeal.participationFeeLabel',
    defaultMessage: 'Participation',
  },
  netCashLabel: {
    id: 'reviewDeal.netCashLabel',
    defaultMessage: 'Net cash',
  },
  editLabel: {
    id: 'reviewDeal.editLabel',
    defaultMessage: 'edit information',
  },
  dateSelectInstruction: {
    id: 'reviewDeal.dateSelectInstruction',
    defaultMessage: 'Please select delivery date of unit:',
  },
  deliveryDateLabel: {
    id: 'reviewDeal.deliveryDateLabel',
    defaultMessage: 'Delivery date selected',
  },
  monthsSuffix: {
    id: 'reviewDeal.monthsSuffix',
    defaultMessage: 'months',
  },
});

export default messages;
